export default __webpack_public_path__ + "static/media/Capaconaut.588e8a89.jpg";